<template>

    <transition-group name="insertion-top" tag="ol" class="timeline" v-if="items.length">

        <li v-for="item in items" class="timeline__item" :class="{ 'is-active': isActive(item), 'is-marked': isMarked(item) }" :key="item.id" @click.prevent="open(item)">
            <slot name="item" v-bind="item" >{{ item }}</slot>
        </li>

    </transition-group>

    <p class="sidebar__empty small" v-else><slot name="empty">Geen {{ collectionName }} gevonden</slot></p>

</template>


<script>

export default {
    components: { },
    props: {
        collectionName: {
            type: String,
            default: 'items',
        },
        items: {
            type: Array,
            default: [],
        },
        isActive: {
            type: Function,
            default: () => false,
        },
        isMarked: {
            type: Function,
            default: () => false,
        },
    },

    methods: {
        open: function(item) {
            if ( item.link ) {
                this.$router.push(item.link)
            } else {
                this.$emit('click', item)
            }
        }
    }
}
</script>



<style lang="scss">

    @import 'global';

    .timeline {

        margin: 1em 0;
        padding: 0 20px;
        list-style: none;

        &__item {
            display: block;
            color: $color-typography-inverted;
            text-decoration: none;
            -webkit-tap-highlight-color: transparent;

            padding: 0 0 13px $timeline-width + 13px;

            position: relative;

            &:before {
                content: "";
                display: block;
                @include sprite-width($timeline);
                @include sprite-image($timeline-2x); // only change this to get retina/non-retina
                @include sprite-background-size($timeline); // always non-retina
                @include sprite-position($timeline); // always non-retina
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
            }


            &.is-marked {

                &:after {
                    content: "";
                    display: block;
                    @include sprite-width($timeline-marked);
                    @include sprite-height($timeline-marked);
                    @include sprite-image($timeline-marked-2x); // only change this to get retina/non-retina
                    @include sprite-background-size($timeline-marked); // always non-retina
                    @include sprite-position($timeline-marked); // always non-retina
                    position: absolute;
                    top: 15px;
                    left: 0;
                }

            }

            &.is-active, &.router-link-active {

                .timeline__hoverable {
                    > * {
                        transform: translate(12px, 0);
                    }
                }

                .timeline__header {
                    background-color: $color-white !important;
                    color: $color-tag;
                }
            }

        }


        &__hoverable {
            cursor: pointer;
            margin-left: -15px;
            -webkit-tap-highlight-color: transparent;

            .timeline__header, .timeline__content {
                padding-left: 15px;
            }

            > * {
                transition: transform 0.7s cubic-bezier(0.28, 0.94, 0.37, 1.00);
                display: block;
            }


            &:hover {
                > * {
                    transition-duration: 0.14s;
                    transform: translate(12px, 0);
                }

                .timeline__header {
                    background-color: transparentize($color-white, 0.86);
                }
            }
        }

        &__header {
            padding: 10px 20px 10px 0;
            margin-right: -20px; // extend to right of sidebar
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }

        &__title {
            margin-top: 0;
            margin-bottom: 0;

            // slight offset due to Hunterswood font baseline being low
            position: relative;
            top: -2px;

            .icon {
                margin-right: 3px;
                margin-left: 3px;
            }
        }

        &__meta {
            color: $color-tag;
            font-size: 0.8em;
            display: block;
            line-height: 1em;
        }

        &__progress {
            font-weight: $font-body-bold-weight;
        }

        &__content {
            font-size: 0.9em;
            padding: 0.8em 0;
            margin: 0;

            &--submission {
                margin-bottom: 24px;
            }

            &--list {
                list-style: none;
                padding-left: 1em;

                // line-up timeline stripes
                margin-bottom: 17px;

                .timeline__subitem {
                    position: relative;
                    &:before {
                        content: "";

                        @include sprite-width($timeline-subitem);
                        @include sprite-height($timeline-subitem);
                        @include sprite-image($timeline-subitem-2x); // only change this to get retina/non-retina
                        @include sprite-background-size($timeline-subitem); // always non-retina
                        @include sprite-position($timeline-subitem); // always non-retina
                        position: absolute;
                        left: -8px;
                        top: 12px;
                    }
                }
            }
        }

        &__subitem {

            color: $color-typography-inverted;
            text-decoration: none;
            -webkit-tap-highlight-color: transparent;

            cursor: pointer;

            > * {
                transition: transform 0.7s cubic-bezier(0.28, 0.94, 0.37, 1.00);
                display: block;
                padding: 2px 20px 2px 8px;
                margin: -2px -20px -2px 0;
                // margin-right: -20px; // extend to right of sidebar
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
            }

            &:hover {
                > * {
                    transition-duration: 0.14s;
                    transform: translate(6px, 0);
                    background-color: transparentize($color-white, 0.86);
                }
            }

            &.is-active {
                > * {
                    transform: translate(6px, 0);
                    background-color: $color-white !important;
                    color: $color-tag;
                }
            }

            &.is-disabled {
                opacity: 0.4;
                text-decoration: line-through;
                &:hover {
                    color: $color-typography-inverted;
                }
            }

        }

        &__thumbnail {
            display: block;
            margin: 0;
            border: 2px solid $color-white;
            border-radius: 6px;
            height: 124px;
            width: 124px;
        }

        &__text {
            word-wrap: break-word;
        }


    }

</style>



// WEBPACK FOOTER //
// Timeline.vue?3d27a108